const stats = [
  { value: "≥80%", label: "Market-moving events correctly flagged ANALYZE" },
  { value: "≤20%", label: "Analyzed events later judged low-impact" },
  { value: "100%", label: "Decisions logged for replay and audit" },
  { value: "v1", label: "US equity options — more asset classes in roadmap" },
];

export default function Stats() {
  return (
    <section className="border-t border-navy-700/60 py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-12">
          <p className="text-sm font-semibold uppercase tracking-widest text-huskly-teal mb-4">
            Success Criteria
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold text-white">
            Designed Around Measurable Quality
          </h2>
        </div>
        <dl className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-xl border border-navy-700 bg-navy-800/40 px-6 py-8 text-center"
            >
              <dt className="text-3xl font-bold text-gradient mb-2">
                {stat.value}
              </dt>
              <dd className="text-sm text-slate-400 leading-snug">
                {stat.label}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
